type Props = {
  /** Quando false, não renderiza nada — fica fácil usar inline. */
  pendente: boolean;
  /** Texto curto opcional. Default: "Aguardando servidor". */
  rotulo?: string;
};

/**
 * Selo amarelo "⏳ Aguardando servidor" exibido enquanto uma entidade
 * cadastrada offline ainda não foi confirmada pelo servidor. Some sozinho
 * quando o worker de push registra a confirmação e atualiza `sync_pendente`.
 */
export function BadgeSyncPendente({ pendente, rotulo = 'Aguardando servidor' }: Props) {
  if (!pendente) return null;
  return (
    <span
      title="Cadastro feito offline — será enviado ao servidor assim que a conexão voltar."
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        background: '#fef3c7',
        color: '#92400e',
        border: '1px solid #fde68a',
        borderRadius: 4,
        padding: '2px 6px',
        fontSize: 10,
        fontWeight: 700,
        textTransform: 'uppercase',
        letterSpacing: 0.06,
        lineHeight: 1.2,
        gap: 4,
      }}
    >
      ⏳ {rotulo}
    </span>
  );
}
